import React from 'react';
import { observer } from 'mobx-react';

import Banner from 'components/Banner';
import { isTrialExpired, getRemainingTrialDays } from 'utils/freeTrials';

export const FreeTrialMessage = observer(({ appManager }) => {
  if (!appManager) return null;

  const { inSpace, hasSubscribed } = appManager;
  if (!inSpace) return null;

  const {
    hasBillingPermissions,
    hasPrivateProjectsSubscription,
    trialPeriodEnd,
    hasValidPaymentMethod,
    spaceType,
    path,
  } = inSpace;

  const isEnjoyingTrial =
    hasPrivateProjectsSubscription &&
    trialPeriodEnd &&
    !isTrialExpired(trialPeriodEnd) &&
    !hasValidPaymentMethod;

  if (!hasSubscribed) {
    if (hasBillingPermissions) {
      // not subscribed and never had a trial
      if (!hasPrivateProjectsSubscription && !trialPeriodEnd) {
        return (
          <Banner>
            Create a private project to start a 30 day free trial of the{' '}
            <a onClick={appManager.showTrialModal}>
              {spaceType === 'PROFILE' ? 'Individual' : `Team`} Plan
            </a>
            , with unlimited collaborators.{' '}
            <strong>No credit card required.</strong>
          </Banner>
        );
      }
      if (isEnjoyingTrial) {
        return (
          <Banner>
            {spaceType === 'PROFILE' ? 'Your' : `${path}'s`} free trial expires
            in {getRemainingTrialDays(trialPeriodEnd)} days. To upgrade early,{' '}
            <a onClick={appManager.subscribe}>subscribe now</a>.
          </Banner>
        );
      }
      if (
        !hasPrivateProjectsSubscription &&
        !hasValidPaymentMethod &&
        isTrialExpired(trialPeriodEnd)
      ) {
        return (
          <Banner variant='warning'>
            Your free trial has expired. To continue collaborating privately,
            please buy a subscription.{' '}
            <a onClick={appManager.subscribe}>Subscribe now</a>
          </Banner>
        );
      }
    } else if (!hasPrivateProjectsSubscription) {
      return (
        <Banner variant='warning'>
          Please contact one of {path}’s admins to start a free trial or
          subscription for this Organisation.
        </Banner>
      );
    }
  }
  return null;
});
